// Feedback táctil/sonoro del panel de puja — progressive enhancement: si el
// navegador no soporta WebAudio / Vibration, degrada en silencio. El
// AudioContext se crea/reanuda con el primer gesto (los navegadores bloquean
// autoplay), por eso `unlock()` se llama en el primer tap.

let ctx = null;

function ensure() {
    if (ctx) return ctx;
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (AC) ctx = new AC();
    } catch { ctx = null; }
    return ctx;
}

// Reanuda el contexto tras un gesto del usuario (necesario en iOS/Chrome).
export function unlock() {
    const c = ensure();
    if (c && c.state === 'suspended') c.resume().catch(() => {});
}

// Beep corto (oscilador). freq alto = subir, bajo = bajar.
export function beep(freq = 660, dur = 0.07, type = 'sine', gain = 0.05) {
    const c = ensure();
    if (!c) return;
    try {
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = type;
        o.frequency.value = freq;
        g.gain.value = gain;
        o.connect(g);
        g.connect(c.destination);
        const t = c.currentTime;
        o.start(t);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        o.stop(t + dur);
    } catch { /* ignore */ }
}

// Acorde corto ascendente para confirmar / hito.
export function chord(freqs = [523, 659, 784], step = 0.06) {
    freqs.forEach((f, i) => setTimeout(() => beep(f, 0.12, 'triangle', 0.06), i * step * 1000));
}

export function vibrate(pattern) {
    try { navigator.vibrate?.(pattern); } catch { /* ignore */ }
}

export const fx = {
    up() { unlock(); beep(680, 0.06, 'sine', 0.05); vibrate(10); },
    down() { unlock(); beep(300, 0.07, 'sine', 0.05); vibrate(10); },
    milestone() { unlock(); chord([523, 659, 784]); vibrate([12, 40, 20]); },
    confirm() { unlock(); chord([659, 784, 988, 1175], 0.05); vibrate([15, 30, 15, 30, 40]); },
    tick() { beep(880, 0.04, 'square', 0.03); },
    go() { unlock(); chord([784, 988, 1319], 0.04); vibrate([30, 20, 60]); },
};
